import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-136" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-left" data-id="element-137" data-mp="1o2lq4y82a9za">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-red-700 sm:h-44 sm:w-44" role="img" aria-label="7 napos elégedettségi garancia" data-id="element-138" data-mp="222wjc7wug0nm">
          <defs data-id="element-139" data-mp="19dzbkyq9dm94">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-140" data-mp="19fsgo9l83yf0" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-141" data-mp="14hh9y7q86410" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-142" data-mp="1j650u0p4lpkm" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-143" data-mp="1ec99hh3db0yf">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-144" data-mp="lp6cwui950at">
              ELÉGEDETTSÉGI GARANCIA · VÁSÁROLJ BIZTONSÁGBAN ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-145" data-mp="oxoyrsyskow5">
            7
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-146" data-mp="yqmang9a3fls">
            NAP
          </text>
        </svg>

        <div data-id="element-147" data-mp="62i30p75csgg">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-148" data-mp="6309sfrfqp2m">
            7 napos elégedettségi garancia
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-900/75" data-id="element-149" data-mp="f0kddvcrsxge">
            Töltsd le az anyagot, és nézd meg, hogyan működik a testnevelésóráidon. Ha a csomag nem felel meg az elvárásaidnak, írj nekünk e-mailt, és a vásárlástól számított 7 napon belül visszakérheted az árát a garanciális feltételek szerint.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-900/60" data-id="element-150" data-mp="1vhever75pvtw">
            A garancia nem érinti a fogyasztóvédelmi jogszabályok szerinti jogaidat.
          </p>
        </div>
      </div>
    </section>;
}